import { Alert, AlertTitle, Button, Dialog, DialogContent, TextField, Typography } from '@mui/material'
import { useState } from 'react';
import ButtonLeft from './buttonLeft';
import { useDispatch, useSelector } from 'react-redux';
import api from '../services/api';
import MessageSuccess from '../messages/messageSuccess';
import MessageError from '../messages/messageError';
import Date from './date';

export default function ReemissaoAutorizacao({ estabelecimento }) {
    const user = useSelector(state => state.account.user);
    const [open, setOpen] = useState(false);
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [numeroAutorizacao, setNumeroAutorizacao] = useState('');
    const [dataAprovacao, setDataAprovacao] = useState('');
    const [load, setLoad] = useState(false);
    const dispatch = useDispatch()
    const handleClose = () => {
        setOpen(false);
    };

    const submitEdit = async () => {
        setLoad(true);
        setMessageSuccess('')
        setMessageError('')
        await api.put('/estabelecimento/edit', {
            'estabelecimentoId': estabelecimento._id,
            numeroAutorizacao,
            dataAprovacao,
            'userId': user?._id ?? ''
        })
            .then(res => {
                setLoad(false)
                setMessageSuccess(res.data.msg)
                // setOpen(false);
                dispatch({
                    type: 'alert',
                    payload: { alert: 'Número de autorização e a data de aprovação foram definidas com sucesso.' },
                });
            }).catch(err => {
                setMessageError(err.response.data.message)
                setLoad(false)
            })
    }


    return (
        <div style={{ marginBottom: 20 }}>
            <Alert severity="info">
                <AlertTitle><b>Solicitação de Reemissão de Autorização de Exercício.</b></AlertTitle>
                Definir o número da autorização actual e a data de vencimento para solicitar a reemissão da autorização de exercício.

                {estabelecimento?.numeroAutorizacao &&
                    <Typography m>
                        Número de Autorização a ser usado: {estabelecimento?.numeroAutorizacao}
                    </Typography>
                }

                {estabelecimento?.dataAprovacao &&
                    <Typography m>
                        Data de Aprovação: <Date date={estabelecimento?.dataAprovacao} />
                    </Typography>
                }

                <Button onClick={() => setOpen(true)} variant="contained" color='secondary' size="small" style={{ marginTop: 20 }}>
                    definir
                </Button>
            </Alert>

            <Dialog
                scroll='body'
                fullWidth
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                {messageSuccess && <MessageSuccess message={messageSuccess} />}
                {messageError && <MessageError message={messageError} />}

                <DialogContent>
                    <TextField onChange={(e) => setNumeroAutorizacao(e.target.value)} defaultValue={estabelecimento?.numeroAutorizacao} label="Número da Autorização" variant="outlined" fullWidth style={{ marginBottom: 20 }} />
                    <TextField onChange={(e) => setDataAprovacao(e.target.value)} defaultValue={estabelecimento?.dataAprovacao} label="Data de Emissão" variant="outlined" fullWidth type='date' InputLabelProps={{ shrink: true }} />

                    <ButtonLeft
                        disabled={(!numeroAutorizacao || !dataAprovacao)}
                        load={load}
                        funcao={submitEdit}
                        title={'salvar'}
                    />

                </DialogContent>
            </Dialog>
        </div>
    )
}
